import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-res-tap-service",
  "use": "oc-res-tap-service-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-res-tap-service\"><path d=\"M896.17 160h-768a64.19 64.19 0 0 0-64 64v512a64.19 64.19 0 0 0 64 64h192v64h384v-64h192a64.19 64.19 0 0 0 64-64V224a64.19 64.19 0 0 0-64-64z m0 576h-768V224h768z\" /><path d=\"M416.17 640h64V352h-32l-32 32-64 64h64v192zM608.17 608l64-64h-64V352h-64v288h32l32-32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol